const defaultState = () => {
    return {
        current_page: 1,
        last_page: 1,
        from: 1,
        to: 1,
        total: 0,
        per_page: 15,
        path: '',
        sortBy: 'id',
        sortDesc: true,
        freeword: '',
    }
}

const state = defaultState()

const mutations = {
    setQuery(state, {key, value}) {
        state[key] = value
    },

    setQueries(state, queries) {
        if (!queries) {
            return;
        }
        
        for (let key of Object.keys(queries)) {
            state[key] = queries[key]
        }
    },

    clearQueries(state) {
        Object.assign(state, defaultState())
    }
};

const getters = {}
const actions = {}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
